import { render, staticRenderFns } from "./projectparam.vue?vue&type=template&id=89e39fd8&"
import script from "./projectparam.vue?vue&type=script&lang=js&"
export * from "./projectparam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports